import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {NavigationConstant} from "@constant/navigation.constant";

@Component({
  selector: 'app-convenience-step',
  templateUrl: './convenience-step.component.html',
  styleUrls: ['./convenience-step.component.css']
})
export class ConvenienceStepComponent implements OnInit {

  class: string;
  icon: string;

  constructor(
      private router: Router
  ) { }

  ngOnInit() {
  }

  goHome() {
    this.router.navigate([NavigationConstant.HOME]);
  }

}
